import React from 'react'; // eslint-disable-line no-unused-vars
import styled from 'react-emotion';

const Spinner = styled('i')`
  color: #ccc;
`;

export default Spinner;
